import { Message as TicketMessage } from "entities/customerTickets/types";
import React, { FC } from "react";
import { useCustomerTicketsPage } from "modules/customerTickets/pages/CustomerTickets/context";
import SupportMessage from "./components/SupportMessage";
import UserMessage from "./components/UserMessage";
import { StyledMessageContainer } from "./styled";

type Props = {
  message: TicketMessage;
};

const Message: FC<Props> = ({ message }) => {
  const { selectedTicket } = useCustomerTicketsPage();

  if (!selectedTicket || !message) {
    return null;
  }

  const isMessageFromUser = message.from === "User";

  return (
    <StyledMessageContainer key={message.id}>
      {isMessageFromUser ? (
        <UserMessage message={message} />
      ) : (
        <SupportMessage message={message} />
      )}
    </StyledMessageContainer>
  );
};

export default Message;
